<template>
  <div class="h-screen flex w-full bg-img vx-row no-gutter items-center justify-center"
       data-test="register-page-container"
       data-analytics="page-register-view"
       data-debug="registration-form">
    <div class="vx-col sm:w-1/2 md:w-1/2 lg:w-3/4 xl:w-3/5 sm:m-0 m-4"
         data-test="register-form-wrapper">
      <vx-card data-test="register-card"
               data-analytics="component-register-card">
        <div slot="no-body" class="full-page-bg-color">
          <div class="vx-row no-gutter">
            <div class="vx-col hidden sm:hidden md:hidden lg:block lg:w-1/2 mx-auto self-center"
                 data-test="register-image-section">
              <img src="@/assets/images/pages/register.jpg" alt="register" class="mx-auto"
                   data-test="register-hero-image"
                   data-analytics="image-register-hero">
            </div>
            <div class="vx-col sm:w-full md:w-full lg:w-1/2 mx-auto self-center  d-theme-dark-bg"
                 data-test="register-form-section"
                 data-analytics="section-register-form">
              <div class="p-8" data-test="register-form-content">
                <div class="vx-card__title" data-test="register-form-header">
                  <h4 class="mb-4" data-test="register-title"
                      data-a11y="registration-form-title">{{ $t('CreateAccount') }}</h4>
                  <p v-if="isFirstTimeSetup" class="text-success font-semibold mb-2"
                     data-test="register-first-time-message"
                     data-analytics="message-first-time-setup"
                     data-a11y="first-time-setup-notification">
                    {{ $t('WelcomeToTCVelik') }}
                  </p>
                  <p v-if="isFirstTimeSetup" class="text-info mb-4"
                     data-test="register-admin-notice"
                     data-analytics="message-admin-creation"
                     data-a11y="admin-creation-notice">
                    {{ $t('YouWillBeAdmin') }}
                  </p>
                  <p v-else data-test="register-instructions"
                     data-analytics="message-registration-instructions"
                     data-a11y="registration-instructions">{{ $t('FillFormToCreateAccount') }}</p>
                </div>
                <div class="clearfix" data-test="register-form-fields"
                     data-analytics="section-form-fields">

                  <vs-input v-validate="'required|email'" data-vv-validate-on="blur" name="email"
                            type="email" label-placeholder="Email" :placeholder="$t('Email')" v-model="email"
                            class="w-full mt-6"
                            data-test="register-email-input"
                            data-analytics="form-field-email"
                            data-a11y="email-input-field"
                            data-debug="email-validation" />
                  <span class="text-danger text-sm" data-test="register-email-error"
                        data-analytics="validation-error-email"
                        data-a11y="email-validation-error">{{ errors.first('email') }}</span>

                  <vs-input ref="password" type="password" data-vv-validate-on="blur"
                            v-validate="'required|min:6|max:50'" name="password"
                            label-placeholder="Password" :placeholder="$t('Password')" v-model="password"
                            class="w-full mt-6"
                            data-test="register-password-input"
                            data-analytics="form-field-password"
                            data-a11y="password-input-field"
                            data-debug="password-validation" />
                  <span class="text-danger text-sm" data-test="register-password-error"
                        data-analytics="validation-error-password"
                        data-a11y="password-validation-error">{{ errors.first('password') }}</span>

                  <vs-input type="password" v-validate="'min:6|confirmed:password'"
                            data-vv-validate-on="blur" data-vv-as="password" name="confirm_password"
                            :label-placeholder="$t('ConfirmPassword')" :placeholder="$t('ConfirmPassword')"
                            v-model="confirm_password" class="w-full mt-6"
                            data-test="register-confirm-password-input"
                            data-analytics="form-field-confirm-password"
                            data-a11y="confirm-password-input-field"
                            data-debug="confirm-password-validation" />
                  <span class="text-danger text-sm" data-test="register-confirm-password-error"
                        data-analytics="validation-error-confirm-password"
                        data-a11y="confirm-password-validation-error">{{ errors.first('confirm_password') }}</span>

                  <vs-checkbox v-model="isTermsConditionAccepted" class="mt-6"
                              data-test="register-terms-checkbox"
                              data-analytics="form-field-terms-acceptance"
                              data-a11y="terms-acceptance-checkbox"
                              data-debug="terms-acceptance-state">
                    {{ $t('AcceptTermsConditions') }}
                  </vs-checkbox>
                  <vs-button type="border" to="/pages/login" class="mt-6"
                            data-test="register-login-link"
                            data-analytics="navigation-login-redirect"
                            data-a11y="login-page-link">{{ $t('Login') }}</vs-button>
                  <vs-button class="float-right mt-6" @click="registerUser"
                             :disabled="!validateForm || RegisterRequestInProgress"
                             data-test="register-submit-button"
                             data-analytics="form-submit-registration"
                             data-a11y="registration-submit-button"
                             data-debug="submit-button-state">{{ $t('Register') }}</vs-button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </vx-card>
    </div>
  </div>
</template>

<script>
  import accountsService from "../../accounts/accountsService";
  export default {
    data() {
      return {
        username: '',
        email: '',
        password: '',
        confirm_password: '',
        account: '',
        isTermsConditionAccepted: true,
        RegisterRequestInProgress: false,
        isFirstTimeSetup: false,
      }
    },
    computed: {
      validateForm() {
        return !this.errors.any() && this.email != '' && this.password != '' && this.confirm_password != '' && this.isTermsConditionAccepted === true;
      }
    },
    watch: {
      // Watch for form validation changes and update debug attributes
      validateForm(newVal) {
        this.$nextTick(() => {
          this.updateDebugAttributes();
        });
      },
      RegisterRequestInProgress(newVal) {
        this.$nextTick(() => {
          this.updateDebugAttributes();
        });
      }
    },
    async mounted() {
      this.mapKeyboardShortcuts();
      // Check if this is a first-time setup
      this.isFirstTimeSetup = this.$route.query.firstTimeSetup === 'true';
      
      // Add dynamic debug attributes
      this.updateDebugAttributes();
    },

    //created() {
    //  const urlParams = new URLSearchParams(window.location.search);
    //  this.isSitefinityCampaign = urlParams.get('campaignname') === 'SitefinityPRT2005';
    //  this.campaignName = urlParams.get('campaignname');
    //},

    methods: {
      updateDebugAttributes() {
        // Update debug attributes based on current state
        const container = document.querySelector('[data-debug="registration-form"]');
        if (container) {
          container.setAttribute('data-debug-state', JSON.stringify({
            isFirstTimeSetup: this.isFirstTimeSetup,
            formValid: this.validateForm,
            requestInProgress: this.RegisterRequestInProgress,
            timestamp: new Date().toISOString()
          }));
        }
      },
      
      mapKeyboardShortcuts() {
        var instance = this;
        document.addEventListener('keydown', function (event) {
          if (event.key === 'Enter') {
            if ((instance.isTermsConditionAccepted == true && instance.validateForm == true) || instance.RegisterRequestInProgress == false) {
              instance.registerUser();
            }
          }
        });
      },
      registerUser() {
        var instance = this;
        
        // Update debug attributes before processing
        instance.updateDebugAttributes();
        
        // Track analytics event
        if (typeof gtag !== 'undefined') {
          gtag('event', 'form_submit', {
            'event_category': 'registration',
            'event_label': 'register_user',
            'value': instance.isFirstTimeSetup ? 1 : 0
          });
        }
        
        if (instance.RegisterRequestInProgress == true) {
          instance.$vs.notify({
            time: 2000,
            title: instance.$t('RegistrationInProgress'),
            text: instance.$t('PleaseWait'),
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'failure'
          });
          return
        }
        instance.RegisterRequestInProgress = true;
        
        // Update debug attributes after state change
        instance.updateDebugAttributes();
        const payload = {
          userDetails: {
            email: this.email,
            password: this.password,
            confirmPassword: this.confirm_password
          },
          notify: this.$vs.notify
        }

        try {
          accountsService.createAccount(payload).then(function (response) {
            if (response) {
              // No automatic login - just show success message
            }
            
            // Track successful registration
            if (typeof gtag !== 'undefined') {
              gtag('event', 'registration_success', {
                'event_category': 'registration',
                'event_label': 'account_created',
                'value': instance.isFirstTimeSetup ? 1 : 0
              });
            }
            
            instance.$vs.notify({
              time: 4000,
              title: instance.$t('Success'),
              text: instance.isFirstTimeSetup 
                ? instance.$t('AdminAccountCreatedSuccessfully')
                : instance.$t('AccountCreatedRedirecting'),
              iconPack: 'feather',
              icon: 'icon-alert-circle',
              color: 'success'
            });

            setTimeout(function () { 
              let redirectUrl = instance.isFirstTimeSetup 
                ? "/pages/login?firstTimeSetup=true" 
                : "/pages/login";
              
              // Preserve redirect_uri if it was in the original request
              if (instance.$route.query.redirect_uri) {
                const separator = redirectUrl.includes('?') ? '&' : '?';
                redirectUrl += `${separator}redirect_uri=${encodeURIComponent(instance.$route.query.redirect_uri)}`;
              }
              
              document.location.href = redirectUrl;
            }, 3000);
          }).catch(function (err) {
            instance.RegisterRequestInProgress = false;
            
            // Track registration error
            if (typeof gtag !== 'undefined') {
              gtag('event', 'registration_error', {
                'event_category': 'registration',
                'event_label': 'account_creation_failed',
                'value': 0
              });
            }
            
            // Update debug attributes with error state
            instance.updateDebugAttributes();
            
            if (err && err.response && err.response.data && err.response.data.Errors) {
              var errs = '';
              for (var i = 0; i < err.response.data.Errors.length; i++) {
                errs += err.response.data.Errors[i].Description + '<br/>';
              }
              instance.$vs.notify({
                time: 8000,
                title: instance.$t('Error'),
                text: instance.$t('AccountNotCreated') + '<br/>' + errs,
                iconPack: 'feather',
                icon: 'icon-alert-circle',
                color: 'danger'
              });
            }
          });
        }
        catch (err) {
          instance.RegisterRequestInProgress = false;
        }
      },
      notifyAlreadyLogedIn() {
        this.$vs.notify({
          title: this.$t('LoginAttempt'),
          text: this.$t('AlreadyLoggedIn'),
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'warning'
        });
      },
    }
  }
</script>
